import { Values } from '../../../../utils/types';

export const SEVERITY = {
  none: 'none',
  medium: 'medium',
  high: 'high',
} as const;

interface GetSeverityProps {
  fileSize: number;
  sizeAlert?: {
    none: number;
    medium: number;
  };
}

export function getSeverity({ fileSize, sizeAlert }: GetSeverityProps): {
  severity: Values<typeof SEVERITY>;
} {
  if (!sizeAlert) return { severity: SEVERITY.none };

  if (fileSize <= sizeAlert.none) {
    return { severity: SEVERITY.none };
  }
  if (fileSize <= sizeAlert.medium) {
    return { severity: SEVERITY.medium };
  }
  return { severity: SEVERITY.high };
}
